<template>
    <div class="cepingwancheng">
        <div>恭喜测评完成</div>
    </div>
</template>
<style type="text/css" lang='less' scoped>
.cepingwancheng {
    width: 100%;
    background-image: url("/imgs/ceping/cepingwancheng.png");
    background-size: cover;
    position: relative;
    div{
        position: absolute;
        left: 50%;
        top: 50%;
        font-size: 95px;
        line-height: 100px;
        color: white;
        letter-spacing: 10px;
        margin-left: -320px;
        margin-top: -50px;
        text-indent: 10px;
    }
}
</style>
<script>
export default {
    props: [ 'message' ],
    data() {
        return {
            // 选科卡账号
        }
    },
    methods: {
        goTest() {
        },
    },
    mounted() {
            let width=$(window).width();
            let height=$(window).height();
            $('.cepingwancheng').css({width:width,height:height})
    },
    created() {
    }
}
</script>
